// BDS CUSTOM: Assorted Hats picker.
// 2026-08-24 rebuild on the tumbler Option-B model: product is now a SINGLE
// per-hat variant with automatic volume discounts (12-23 = $20.00, 24-47 =
// $17.92, 48+ = $16.15). Pack sizes (12/24/48) are UI presets that dictate
// quantity, not variants. Mirrors assets/tumbler-picker.js; no fee variant
// because hats have no per-piece upcharge.
//
// Behavior:
//   TOTAL = packSize × numberOfPacks
//   ATC posts one line { id: variantId, quantity: TOTAL }
//   Automatic discounts price it at checkout so the actual cart total
//   matches the summary preview.
//   Assortment preference input removed 2026-08-24 — shoppers use the
//   Notes field at checkout instead.

(function () {
  'use strict';

  // Per-hat tier price (cents). Mirrors the store-side automatic discount
  // schedule so the Adding-to-Cart preview reflects what the cart will charge.
  function tierCentsForTotal(total) {
    if (total >= 48) return 1615;
    if (total >= 24) return 1792;
    return 2000;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('bds-hat-form');
    if (!form) return;

    var packs      = form.querySelectorAll('[data-bds-pack]');
    var packRadios = form.querySelectorAll('input[name="bds-hat-pack"]');
    var qtyInput   = document.getElementById('bds-hat-qty');
    var minusBtn   = document.getElementById('bds-hat-minus');
    var plusBtn    = document.getElementById('bds-hat-plus');
    var atcBtn     = document.getElementById('bds-hat-atc-btn');
    var errorEl    = document.getElementById('bds-hat-error');

    var variantId  = parseInt(form.dataset.variantId, 10);

    var summaryLabel  = form.querySelector('[data-bds-hat-line-label]');
    var summaryDetail = form.querySelector('[data-bds-hat-line-detail]');
    var summaryTotal  = form.querySelector('[data-bds-hat-total]');
    var USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    function fmt(cents) { return USD.format(cents / 100); }

    // ── Pack selection (UI-only; drives packSize, not variant id) ────────────
    function selectPack(packSize) {
      packs.forEach(function (p) {
        var match = String(p.dataset.packSize) === String(packSize);
        p.classList.toggle('bds-hat-pack--selected', match);
        var radio = p.querySelector('input[type="radio"]');
        if (radio) radio.checked = match;
      });
      renderAddingSummary();
    }
    function selectedPackSize() {
      var radio = form.querySelector('input[name="bds-hat-pack"]:checked');
      var n = radio ? parseInt(radio.dataset.packSize || radio.value, 10) : NaN;
      return (!n || n < 1) ? 12 : n;
    }
    packRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) selectPack(parseInt(radio.dataset.packSize || radio.value, 10));
      });
    });

    // ── Pack qty stepper ─────────────────────────────────────────────────────
    function currentQty() {
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) return 1;
      return n;
    }
    function setQty(n) {
      qtyInput.value = String(Math.max(1, n));
      minusBtn.disabled = currentQty() <= 1;
      renderAddingSummary();
    }
    minusBtn.addEventListener('click', function () { setQty(currentQty() - 1); });
    plusBtn .addEventListener('click', function () { setQty(currentQty() + 1); });
    qtyInput.addEventListener('input', function () { minusBtn.disabled = currentQty() <= 1; renderAddingSummary(); });
    qtyInput.addEventListener('blur',  function () { setQty(currentQty()); });

    // ── Adding-to-Cart summary (TOTAL-based tier price) ──────────────────────
    function renderAddingSummary() {
      if (!summaryLabel || !summaryDetail || !summaryTotal) return;
      var total     = selectedPackSize() * currentQty();
      var unitCents = tierCentsForTotal(total);
      var lineCents = unitCents * total;

      summaryLabel.textContent  = 'Hats';
      summaryDetail.textContent = total + ' × ' + fmt(unitCents) + ' = ' + fmt(lineCents);
      summaryTotal.textContent  = fmt(lineCents);
    }

    // ── Submit handler ───────────────────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      doAtc();
    }, true);

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
    }

    function doAtc() {
      if (atcBtn.disabled) return;
      if (!variantId) {
        showError('Hat variant is unavailable. Please refresh and try again.');
        return;
      }

      var total = selectedPackSize() * currentQty();

      var line = { id: variantId, quantity: total };

      var originalText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding…';
      errorEl.style.display = 'none';

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = {
        items: [line],
        sections:     cart ? cart.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'],
        sections_url: window.location.pathname
      };

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(body)
      })
        .then(async function (res) {
          if (!res.ok) {
            var e = await res.json().catch(function () { return {}; });
            throw new Error(e.description || 'Could not add to cart.');
          }
          var responseData = await res.json();
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bds-hat-packs', cartData: responseData });
          }
          if (cart) {
            cart.renderContents(responseData);
          } else {
            var newBubbleHTML = responseData.sections && responseData.sections['cart-icon-bubble'];
            var liveBubble = document.getElementById('cart-icon-bubble');
            if (newBubbleHTML && liveBubble) {
              var parsed = new DOMParser().parseFromString(newBubbleHTML, 'text/html');
              var inner = parsed.querySelector('.shopify-section');
              if (inner) liveBubble.innerHTML = inner.innerHTML;
            }
          }
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
          showError(err.message || 'Something went wrong. Please try again.');
        });
    }

    // ── Initial state ────────────────────────────────────────────────────────
    setQty(currentQty());
    renderAddingSummary();
  });
})();
